import React from "react";
import { Button, Skeleton } from "@mui/material";
import TriggerLinkIcon from "../../assets/images/icons/link.png";

type Props = {
  type: "applicant" | "coapplicant";
  coApplicantIndex?: number | string;
  disabled?: boolean;
  loading?: boolean;
  onClick?: (context: { type: Props["type"]; coApplicantIndex?: number | string }) => void;
};

const ConsentAuthorizationButton: React.FC<Props> = ({
  type,
  coApplicantIndex,
  disabled = false,
  loading = false,
  onClick,
}) => {
  return (
    <Button
      type="button"
      variant="text"
      disabled={disabled || loading}
      onClick={(event) => {
        event.stopPropagation();
        onClick?.({ type, coApplicantIndex });
      }}
      sx={{
        minHeight: 32,
        borderRadius: "6px",
        borderColor: "transparent",
        color: "#00b3b5",
        textTransform: "none",
        fontWeight: 600,
        fontSize: "12px",
        letterSpacing: ".43px",
        whiteSpace: "nowrap",
        px: 0 ,
      }}
    >
      {loading ? (
        <Skeleton
          animation="wave"
          variant="text"
          width={190}
          sx={{ bgcolor: "rgba(0, 179, 181, 0.25)" }}
        />
      ) : (
        <>
            <img
              className={disabled || loading ? "disabled-img" : ""}
              src={TriggerLinkIcon}
              alt=""
              style={{
                width: 16,
                height: 16,
                marginRight: 5,
                opacity: disabled || loading ? 0.5 : 1,
                pointerEvents: disabled || loading ? "none" : "auto",
              }}
            />
          Trigger Consent & OTP Authorization
        </>
      )}
    </Button>
  );
};

export default ConsentAuthorizationButton;
